import "core-js/modules/es.array.includes";
import "core-js/modules/es.array.map";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.string.includes";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { Message } from "element-ui";
import { addProduct, updProduct, searchProduct } from "@/api/management/productMapping";
import { serchSelectManage } from "@/mixins/index";
export default {
  mixins: [serchSelectManage],
  data: function data() {
    return {
      dialogFormVisible: false,
      searchData: {
        id: "",
        game: "",
        platform: "",
        channel: "",
        appid: "",
        pkg: "",
        name: "",
        icon: ""
      },
      fileList: [],
      allProduct: {},
      rules: {
        game: [{
          required: true,
          message: this.$t('pleaseSelectGame'),
          trigger: "blur"
        }],
        platform: [{
          required: true,
          message: this.$t('pleaseSelectPlatform'),
          trigger: "blur"
        }],
        channel: [{
          required: true,
          message: this.$t('pleaseSelectChannel'),
          trigger: "blur"
        }],
        pkg: [{
          required: true,
          message: this.$t('pleaseSelectPackageName'),
          trigger: "blur"
        }],
        name: [{
          required: true,
          message: this.$t('pleaseInputProductNameLabel'),
          trigger: "blur"
        }],
        icon: [{
          required: true,
          message: this.$t('pleaseUploadIcon'),
          trigger: "blur"
        }]
      },
      objToKey: function objToKey(obj) {
        return Object.keys(obj).map(function (k) {
          return obj[k];
        });
      }
    };
  },
  created: function created() {// searchgame().then((res) => {
    //   if (res.status == 200) {
    //     this.searchgames = this.ArrayAddition(res.data);
    //   }
    // });
  },
  methods: {
    init: function init(data) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var i;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.dialogFormVisible = true;

                if (!data) {
                  _context.next = 10;
                  break;
                }

                _context.next = 4;
                return _this.gamechangeManage(data.game);

              case 4:
                _context.next = 6;
                return _this.platformchangeManage(data.platform);

              case 6:
                _context.next = 8;
                return _this.channelchangeManage(data.channel);

              case 8:
                for (i in _this.searchData) {
                  _this.searchData[i] = data[i] || '';
                }

                _this.fileList = [{
                  url: data.icon.includes('https') ? data.icon : _this.$utils.imgTrow(data.icon)
                }];

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    BgUrl: function BgUrl(e) {
      this.fileList = e;
      this.searchData.icon = e[0] ? e[0].url : '';
    },
    resetForm: function resetForm() {
      this.dialogFormVisible = false;
      this.searchData.id = '';
      this.clearData();
    },
    clearData: function clearData() {
      var isC = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      this.searchData = {
        id: this.searchData.id,
        game: "",
        platform: "",
        channel: "",
        appid: isC ? this.searchData.appid : '',
        pkg: "",
        name: "",
        icon: ""
      };
      this.searchplatforms = [];
      this.searchchannels = [];
      this.searchpkgs = [];
      this.fileList = [];
      this.$refs.ruleForm.resetFields();
    },
    dataFormSubmit: function dataFormSubmit() {
      var _this2 = this;

      this.$refs.ruleForm.validate(function (vaild) {
        if (vaild) {
          var data = JSON.parse(JSON.stringify(_this2.searchData));
          data.icon = data.icon.replaceAll(_this2.$imgUrl, '');
          var reqFn = _this2.searchData.id ? updProduct : addProduct;
          reqFn(data).then(function (res) {
            if (res.status == 200) {
              _this2.$store.dispatch('d2admin/serchSelect/getAllGame');

              _this2.$store.dispatch('d2admin/serchSelect/getAllProduct');

              Message.success(_this2.$t('operationSuccess'));

              _this2.resetForm();

              _this2.$emit("change", false);
            }
          });
        }
      });
    }
  }
};